module.exports = __webpack_public_path__ + "static/media/dpl-logo-text-white.9abfa6b3.png";